import { connect } from 'react-redux'
import Component from './Component'

import componentWillMount from './Handlers/componentWillMount'
import onClickNew from './Handlers/onClickNew'
import onClickRecord from './Handlers/onClickRecord'

const mapStateToProps = () => ({})

const actionCreators = {
  componentWillMount,
  onClickNew,
  onClickRecord,
}

export default connect(mapStateToProps, actionCreators)(Component)
